import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=f39983a6&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"
import style0 from "./Blog.vue?vue&type=style&index=0&id=f39983a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39983a6",
  null
  
)

export default component.exports